import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = () => ({
  root: {
    margin: '110px 0',
  },
})

const TablePreloader = ({
  size, color, classes, className 
}) => {
  const colorIsHex = color && color.charAt(0) === '#'
  const colorProp = color && !colorIsHex ? color : 'primary'
  const colorStyle = color && colorIsHex ? { color } : null

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classNames(classes.root, className)}>
      <CircularProgress
        size={size || 30}
        color={colorProp}
        style={colorStyle}
      />
    </Grid>
  )
}

TablePreloader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(TablePreloader)



// WEBPACK FOOTER //
// ./src/components/atoms/TablePreloader.js